import Quest from "./Quest";

export default class QuestBossFight extends Quest {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);

        this._boss = "";
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);

        this._boss = metadata.boss;
    }

    /**
     * @param {GameScene} game
     */
    onFightStart(game) {
    }

    /**
     * @param {GameScene} game
     * @param {boolean} success
     */
    onFightEnd(game, success) {
    }

    /**
     * @return {string}
     */
    get boss() {
        return this._boss;
    }
}